export default "__VITE_ASSET__BS$mAjny__"